export default function MobileStickyActions({ children }) {
  return (
    <div className="sticky bottom-0 border-t border-primary bg-mgs-bg px-4 py-3 shadow-[0_-4px_12px_rgba(0,0,0,0.35)]">
      <div className="flex gap-3">{children}</div>
    </div>
  );
}
